import React, { FC } from 'react';
import { useQuery }  from '@apollo/react-hooks';

import { DecisionEngineQueries }         from '../../../../queries';
import { formatOption }                  from '../../../../util';
import { SelectField, SelectFieldProps }              from '../../../components/forms';
import { CorvalDataValueSet, PreSelectedSelectField } from '../../../../types';

const QueryDropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let { data, loading, error } = useQuery( DecisionEngineQueries.queries.GET_DATA_VALUE_SETS( `id name` ), { fetchPolicy: 'cache-and-network' } );
	
	let isLoading = ( props.loading || loading );
	
	let options = ( data )
	              ? data.dataValueSets.map( ( dataValue: CorvalDataValueSet ) => formatOption( dataValue.id, dataValue.name ) )
	              : [];
	
	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

QueryDropdown.defaultProps = {
	loading: false,
};

export { QueryDropdown as DataValueSetDropdown };
